import { render, staticRenderFns } from "./BaseOverlay.vue?vue&type=template&id=77790462&functional=true&"
import script from "./BaseOverlay.vue?vue&type=script&lang=ts&"
export * from "./BaseOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./BaseOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports